import { Navigate, useParams } from '@exam-center/router';
import { dayjs } from '@shared/utils';

export default function ExamEventsYearPage() {
  const { examCenterCode } = useParams('/:examCenterCode/exam-events/years/:year');
  const currentYear = dayjs().year();

  // Navigate User to Current Year Exam Events Page
  return (
    <Navigate
      to='/:examCenterCode/exam-events/years/:year'
      replace
      params={{ examCenterCode, year: currentYear.toString() }}
    />
  );
}
